import { ActionTypes } from "../constants/action-types";
import { createAction } from "redux-actions";
import { search, updateTaskField, getItem, bulkDeleteItems } from "../api/ProjectApi";

const api = {
  [ActionTypes.searchItems]: async ({
    projectId,
    page,
    pageSize,
    filters,
    view,
    types,
    sorts,
    fields,
  }) => {
    const data = await search({
      projectId,
      filters,
      page,
      pageSize,
      view,
      types,
      sorts,
      ...(fields && { fields }),
    });
    return { data, view };
  },
  [ActionTypes.getItem]: (taskId) => getItem(taskId),
  [ActionTypes.updateTask]: (taskId, fieldId, fieldValue, itemType, view) =>
    updateTaskField(taskId, fieldId, fieldValue, itemType, view),
  [ActionTypes.resetTask]: (itemType) => ({ itemType }),
  [ActionTypes.selectAllItems]: ({ view, selected }) => ({ view, selected }),
  [ActionTypes.selectItem]: ({ view, itemId, itemIndex, selected }) => ({
    itemIndex,
    view,
    itemId,
    selected,
  }),
  [ActionTypes.bulkDeleteItems]: ({ itemIds, type }) => bulkDeleteItems({ itemIds, type }),
  [ActionTypes.changeFilters]: (filters) => ({ filters }),
  [ActionTypes.changeSorts]: (sorts) => ({ sorts }),
  [ActionTypes.changeGroupBy]: (groupId: string, groupColumnIds: string[]) => ({
    groupId,
    groupColumnIds,
  }),
  [ActionTypes.changeBoardCardFields]: (fields: string[]) => fields,
  [ActionTypes.changeGridFields]: (fields: string[]) => fields,
  [ActionTypes.changeShowCardLabels]: (showCardLabels: boolean) => showCardLabels,
  [ActionTypes.changeViewModeData]: (fieldId, fieldValue) => ({
    fieldId,
    fieldValue,
  }),
  [ActionTypes.showViewModeDialog]: (data) => data,
  [ActionTypes.hideViewModeDialog]: () => ({}),
  [ActionTypes.changeFilterString]: (filterString, searchMode) => ({
    filterString,
    searchMode,
  }),
  // Synchronous action: merge refreshed data into existing task without API call
  [ActionTypes.updateTaskData]: (taskId: string, item: any, view?: string) => ({
    taskId,
    item,
    view: view || "BOARD",
  }),
  [ActionTypes.showTaskDialog]: (task, contentType) => ({ task, contentType }),
  [ActionTypes.hideTaskDialog]: (contentType) => ({ contentType }),
  [ActionTypes.updateTaskDialog]: (contentType, fieldId, fieldValue) => ({
    contentType,
    fieldId,
    fieldValue,
  }),
  [ActionTypes.resetTaskDialog]: (contentType, taskData) => ({ contentType, taskData }),
  [ActionTypes.showRightPanelDialog]: (data, dialogType) => ({ data, dialogType }),
  [ActionTypes.hideRightPanelDialog]: (dialogType) => ({ dialogType }),
};

const actions: any = { ...api };

Object.keys(actions).forEach((type) => {
  actions[type] = createAction(type, actions[type]);
});

export default actions;
